const gridProfile = {
  gridProfile: {
    pageHeader: 'グリッドプロファイル',
    name: '名称',
    description: '説明',
    createdBy: '作成者',
    noGrid: '** 利用可能なグリッドはありません **',
    grids: 'グリッド'
  }
};

export default gridProfile;
